/** @typedef {string} RelativeDateType */
export const RELATIVE_DATE_TYPE_TODAY = 'TODAY';
export const RELATIVE_DATE_TYPE_YESTERDAY = 'YESTERDAY';
export const RELATIVE_DATE_TYPE_FIRST_OF_CURRENT_MONTH = 'FIRST_OF_CURRENT_MONTH';
export const RELATIVE_DATE_TYPE_LAST_OF_CURRENT_MONTH = 'LAST_OF_CURRENT_MONTH';
/** @enum {RelativeDateType} */
export const RELATIVE_DATE_TYPE = {
	TODAY: RELATIVE_DATE_TYPE_TODAY,
	YESTERDAY: RELATIVE_DATE_TYPE_YESTERDAY,
	FIRST_OF_CURRENT_MONTH: RELATIVE_DATE_TYPE_FIRST_OF_CURRENT_MONTH,
	LAST_OF_CURRENT_MONTH: RELATIVE_DATE_TYPE_LAST_OF_CURRENT_MONTH,
};
/** @type {RelativeDateType[]} */
export const RELATIVE_DATE_TYPES = Object.values(RELATIVE_DATE_TYPE);


/** @typedef {string} RelativeDateUnit */
export const RELATIVE_DATE_UNIT_DAYS = 'DAYS';
export const RELATIVE_DATE_UNIT_MONTHS = 'MONTHS';
export const RELATIVE_DATE_UNIT_YEARS = 'YEARS';
/** @enum {RelativeDateUnit} */
export const RELATIVE_DATE_UNIT = {
	DAYS: RELATIVE_DATE_UNIT_DAYS,
	MONTHS: RELATIVE_DATE_UNIT_MONTHS,
	YEARS: RELATIVE_DATE_UNIT_YEARS,
};
/** @type {RelativeDateUnit[]} */
export const RELATIVE_DATE_UNITS = Object.values(RELATIVE_DATE_UNIT);